import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Switch.module.css';
export const Switch = forwardRef(({ label, ...props }, ref) => {
    return (_jsxs("div", { className: styles.rememberMe, children: [_jsxs("label", { className: styles.switch, children: [_jsx("input", { ref: ref, type: "checkbox", ...props }), _jsx("span", { className: styles.slider })] }), label && _jsx("span", { children: label })] }));
});
Switch.displayName = 'Switch';
